import { useCallback, useEffect, useMemo, useState } from "react";
import SliderGate from "./components/SliderGate";
import EntryPage from "./components/EntryPage";
import LinkExpired from "./components/LinkExpired";
import {
  isGateLinkExpired,
  isNavLinkExpired,
  parseGateTimestamp,
  parseNavTimestamp,
} from "./utils/subdomainLinkExpiry";
import { initGateAntiBot } from "./utils/gateAntiBot";

function isEntryRoute() {
  const hash = window.location.hash || "";
  const path = hash.replace(/^#/, "").split("?")[0];
  return path === "/entry" || path === "entry";
}

function isDevHost(hostname) {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)
  );
}

function resolveMode(hostname) {
  if (parseNavTimestamp(hostname)) return "entry";
  if (parseGateTimestamp(hostname)) return "gate";
  if (isDevHost(hostname)) {
    return isEntryRoute() ? "entry" : "gate";
  }
  return "invalid";
}

/** n 子域若未带 #/entry，把 search 挪到 hash 并补上 /entry */
function useNavEntryHash() {
  useEffect(() => {
    if (!parseNavTimestamp(window.location.hostname) || isEntryRoute()) {
      return;
    }
    const url = new URL(window.location.href);
    const qs = url.searchParams.toString();
    url.search = "";
    url.hash = qs ? `#/entry?${qs}` : "#/entry";
    window.history.replaceState(null, "", url.toString());
  }, []);
}

function App() {
  const hostname = window.location.hostname;
  const [forceExpired, setForceExpired] = useState(false);
  const baseMode = useMemo(() => resolveMode(hostname), [hostname]);

  const onExpired = useCallback(() => setForceExpired(true), []);

  useNavEntryHash();

  useEffect(() => {
    const anti = initGateAntiBot();
    return () => anti?.dispose?.();
  }, []);

  if (forceExpired) {
    return <LinkExpired />;
  }

  if (baseMode === "gate") {
    if (parseGateTimestamp(hostname) && isGateLinkExpired(hostname)) {
      return <LinkExpired />;
    }
    return <SliderGate />;
  }

  if (baseMode === "entry") {
    if (parseNavTimestamp(hostname) && isNavLinkExpired(hostname)) {
      return <LinkExpired />;
    }
    return <EntryPage onExpired={onExpired} />;
  }

  return <LinkExpired />;
}

export default App;
